export const COUNTRIES = 'COUNTRIES';



// WEBPACK FOOTER //
// ./src/store/modules/country/mutation-types.js